import * as React from 'react';
import { Fade } from 'view/common/transitions';
import { HelpTextContainer } from './styled';

export interface Props {
    helpText: string;
}

class RequestCreateFormHelpTextDumb extends React.Component<Props> {
    render() {
        return (
            <Fade in={!!this.props.helpText}>
                <HelpTextContainer dangerouslySetInnerHTML={{ __html: this.props.helpText }} />
            </Fade>
        );
    }
}

export default RequestCreateFormHelpTextDumb;
